import { useHseSummary } from "@dashboard/hooks/useHseSummary";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { StatCard } from "./StatCard";

export default function YourRisks() {
    const { t } = useTranslation();
    const { data: summary, isPending, isError } = useHseSummary();

    const linkHref = summary && !Array.isArray(summary.links) ? summary.links.risks : undefined;

    return (
        <StatCard
            label={t("dashboard.yourRisks")}
            value={summary?.metrics.risks.total}
            isPending={isPending}
            isError={isError}
            icon={faTriangleExclamation}
            variant="pink"
            linkHref={linkHref}
            linkLabel={t("dashboard.manageRisks")}
        />
    );
}
